const smartFieldStyle = {
  userSelect: 'none',
  backgroundColor: '#f3f3f3',
  border: '1px solid #ccc',
  padding: '2px 4px',
  borderRadius: '4px',
  display: 'inline-block'
};

const SpendingTable = () => {
  return (
    <table contentEditable={false} id="spendingTable" border="1" style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center' }}>
      <thead>
        <tr>
          <th contentEditable={false}></th>
          <th colSpan="3" contentEditable={false}>Frais d'hébergement</th>
          <th colSpan="3" contentEditable={false}>Frais de restauration</th>
        </tr>
        <tr>
          <th contentEditable={false}></th>
          <th contentEditable={false}>Nombre</th>
          <th contentEditable={false}>X</th>
          <th contentEditable={false}>Montant (€)</th>
          <th contentEditable={false}>Nombre</th>
          <th contentEditable={false}>X</th>
          <th contentEditable={false}>Montant (€)</th>
        </tr>
      </thead>
      <tbody>
        {[1, 2, 3, 4].map((year) => (
          <tr key={year}>
            <td contentEditable={false}>{`Année ${year} de financement`}</td>
            <td contentEditable={false}><span data-smartfield={`[hebergementNbr${year}/]`} contentEditable={false} style={smartFieldStyle}>Nbr Hébergement {year}</span></td>
            <td contentEditable={false}>X</td>
            <td contentEditable={false}><span data-smartfield={`[hebergementMontant${year}/]`} contentEditable={false} style={smartFieldStyle}>Mt Hébergement {year}</span></td>
            <td contentEditable={false}><span data-smartfield={`[restaurationNbr${year}/]`} contentEditable={false} style={smartFieldStyle}>Nbr Restauration {year}</span></td>
            <td contentEditable={false}>X</td>
            <td contentEditable={false}><span data-smartfield={`[restaurationMontant${year}/]`} contentEditable={false} style={smartFieldStyle}>Mt Restauration {year}</span></td>
          </tr>
        ))}
        <tr>
          <td contentEditable={false}>Total</td>
          <td contentEditable={false}><span data-smartfield="[hebergementNbrTotal/]" contentEditable={false} style={smartFieldStyle}>Total Nombre Hébergement</span></td>
          <td contentEditable={false}></td>
          <td contentEditable={false}><span data-smartfield="[hebergementMontantTotal/]" contentEditable={false} style={smartFieldStyle}>Total Montant Hébergement</span></td>
          <td contentEditable={false}><span data-smartfield="[restaurationNbrTotal/]" contentEditable={false} style={smartFieldStyle}>Total Nombre Restauration</span></td>
          <td contentEditable={false}></td>
          <td contentEditable={false}><span data-smartfield="[restaurationMontantTotal/]" contentEditable={false} style={smartFieldStyle}>Total Montant Restauration</span></td>
        </tr>
      </tbody>
    </table>
  );
};

export default SpendingTable;